import { loadItems } from 'state/teamsnap/actions';

const loadDivisionsPreferences = divisionId => dispatch => dispatch(loadItems('divisionsPreferences', { divisionId }));

export { loadDivisionsPreferences };
